import React from 'react';

export default class ModalFooter extends React.Component {
  static propTypes = {
    children: React.PropTypes.node
  };

  render () {
    return <div className="modal__footer">
      {this.props.children}
    </div>;
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/common/modal/footer.js